import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AddressForm from '../../components/AddressForm';
import { useAppContext } from '../../contexts/AppContext';
import storeServiceCreator from '../../utils/StoreService';
import RewardsForm from '../../components/RewardsForm';
import { IconButton } from '@mui/material';
import { ArrowBack, Save } from '@mui/icons-material';

const StoreEdit = () => {
    const { storeId } = useParams();
    const { appState, updateAppState } = useAppContext();
    const StoreService = storeServiceCreator();

    const [storeData, setStoreData] = useState<any>(null);

    useEffect(() => {
        if (!storeId) {
            return;
        }
        const fetchStoreData = async () => {
            const response = await StoreService.getStoreAsync(storeId);
            if (response.status !== 200) {
                return;
            }
            const store = response.data;
            setStoreData(store);
            updateAppState({ newStoreAddress: store.address, newStoreRewards: store.rewards });
        };

        fetchStoreData();
    }, []);

    const handleSave = async () => {
        if (!storeId) {
            console.error('Store ID is undefined');
            return;
        }
        const response = await StoreService.updateStoreAsync(storeId, {
            Name: appState.newStoreAddress?.storeName,
            Address: {
                AddressLine1: appState.newStoreAddress?.address1,
                AddressLine2: appState.newStoreAddress?.address2,
                City: appState.newStoreAddress?.city,
                PostalCode: appState.newStoreAddress?.postalCode,
                Country: appState.newStoreAddress?.country
            },
            Logo: appState.newStoreAddress?.logo,
            Rewards: appState.newStoreRewards,
            PhoneNumber: appState.newStoreAddress?.phone,
            Website: appState.newStoreAddress?.website
        });

        if (response.status === 204) {
            // Handle success, set a success message
            updateAppState({
                success: 'Store updated successfully'
            });
        }
    };

    if (!storeData) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Grid
            container
            sx={{
                height: {
                    xs: '100%',
                    sm: 'calc(100dvh - var(--template-frame-height, 0px))',
                },
                mt: {
                    xs: 4,
                    sm: 0,
                },
            }}
        >
            <Grid
                size={{ sm: 12, md: 12, lg: 12 }}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '100%',
                    width: '100%',
                    backgroundColor: { xs: 'transparent', sm: 'background.default' },
                    alignItems: 'center',
                    pt: { xs: 0, sm: 16 },
                    px: { xs: 2, sm: 10 },
                    gap: { xs: 4, md: 8 },
                }}>
                <Box sx={{ mt: 4 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button endIcon={<ArrowBack />} variant="outlined" onClick={() => window.history.back()}>
                            Back
                        </Button>
                    </Box>
                    <Typography variant="h4">Edit Store</Typography>
                    <AddressForm initialValues={{
                        storeName: storeData.name,
                        phone: storeData.phoneNumber,
                        address1: storeData.address.addressLine1,
                        address2: storeData.address.addressLine2,
                        city: storeData.address.city,
                        postalCode: storeData.address.postalCode,
                        country: storeData.address.country,
                        logo: storeData.logo,
                    }} />
                    <RewardsForm
                        initialValues={storeData.rewards}
                    >

                    </RewardsForm>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'end',
                    }} >
                        <Button sx={{
                            
                        }} endIcon={<Save />} variant="contained" onClick={handleSave}>
                            Save
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default StoreEdit;
